import { useCallback, useEffect, useState } from 'react';
import { GetAdminSubscriptionsOverviewAPI } from '../../../../api/AdminAPI';

const DEFAULT_SUMMARY = {
  active_subscriptions: 0,
  stripe_trialing: 0,
  canceling: 0,
  past_due: 0,
  in_trial: 0,
  trial_expiring: 0,
  trial_expired_no_subscription: 0,
  legacy_no_trial: 0,
  failed_payments_30d: 0,
};
const DEFAULT_DAYS_AHEAD = 7;

/**
 * useAdminSubscriptions
 *
 * Hook responsável pela tela "Assinaturas" do Admin Geral: visão consolidada de assinaturas,
 * trials e problemas de pagamento (overview.php). Sem paginação — cada seção já limita o
 * volume de linhas no backend (ex.: trial_expired até 100 linhas).
 *
 * @returns {Object} estado e ações da tela
 */
function useAdminSubscriptions() {
  const [includeTest, setIncludeTest] = useState(false);
  const [daysAhead, setDaysAhead] = useState(DEFAULT_DAYS_AHEAD);

  const [summary, setSummary] = useState(DEFAULT_SUMMARY);
  const [trialExpiring, setTrialExpiring] = useState([]);
  const [trialExpired, setTrialExpired] = useState([]);
  const [paymentIssues, setPaymentIssues] = useState([]);
  const [canceling, setCanceling] = useState([]);
  const [generatedAt, setGeneratedAt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOverview = useCallback(() => {
    setIsLoading(true);
    setError(null);
    GetAdminSubscriptionsOverviewAPI(
      { include_test: includeTest ? 1 : 0, days_ahead: daysAhead },
      (response) => {
        if (!response || response.success === false) {
          setError(response?.error || 'Erro ao carregar as assinaturas. Tente novamente.');
          setIsLoading(false);
          return;
        }
        setSummary(response.summary || DEFAULT_SUMMARY);
        setTrialExpiring(response.trial_expiring || []);
        setTrialExpired(response.trial_expired || []);
        setPaymentIssues(response.payment_issues || []);
        setCanceling(response.canceling || []);
        setGeneratedAt(response.generated_at || null);
        setIsLoading(false);
      }
    );
  }, [includeTest, daysAhead]);

  useEffect(() => {
    fetchOverview();
  }, [fetchOverview]);

  return {
    includeTest,
    setIncludeTest,
    daysAhead,
    setDaysAhead,

    summary,
    trialExpiring,
    trialExpired,
    paymentIssues,
    canceling,
    generatedAt,
    isLoading,
    error,

    refresh: fetchOverview,
  };
}

export default useAdminSubscriptions;
